import * as z from "zod";
import { getAvailableIntegrations } from "./get-available-integrations";
import { getGen2IntegrationStatuses } from "./integrations/get-gen2-integration-statuses";
import { getAllIntegrationStatuses } from "./returns-rpc/get-all-integration-statuses";

/**
 * Every status source the unified integrations page needs, in one round trip;
 * the server fans out to the same computations the individual RPCs use.
 */
export const getCatalogStatuses = {
  name: "getCatalogStatuses" as const,
  input: z.object({
    /** Unknown kinds in both lists are ignored so mixed client/server versions coexist. */
    gen2Kinds: z.array(z.string()),
    gen3Kinds: z.array(z.string()),
  }),
  output: z.object({
    hub: getAllIntegrationStatuses.output,
    gen2: getGen2IntegrationStatuses.output,
    gen3: getAvailableIntegrations.output,
  }),
};
